import React from "react";
import { KeyRound } from "lucide-react";

export default function GstVaultBanner({ summary, onFilter, active }) {
  if (!summary || !summary.gst_clients) return null;
  const parts = [
    { k: "expired", n: summary.expired, cls: "text-rose-700", label: "expired" },
    { k: "expiring", n: summary.expiring, cls: "text-amber-800", label: "expiring soon" },
    { k: "missing", n: summary.missing, cls: "text-zinc-600", label: "without login" },
  ].filter((p) => p.n > 0);
  if (!parts.length) return null;
  return (
    <div data-testid="gst-vault-banner" className="border border-zinc-900 bg-zinc-50 px-4 py-2.5 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs">
      <span className="flex items-center gap-1.5 font-semibold"><KeyRound size={13} /> GST portal logins</span>
      {parts.map((p) => (
        <button key={p.k} data-testid={`gst-vault-filter-${p.k}`} onClick={() => onFilter(active === p.k ? "" : p.k)}
          className={`font-semibold ${p.cls} underline decoration-dotted ${active === p.k ? "bg-zinc-900 text-white px-1.5 no-underline" : ""}`}>
          {p.n} {p.label}
        </button>
      ))}
      {active ? <button data-testid="gst-vault-filter-clear" onClick={() => onFilter("")} className="ml-auto text-zinc-500 hover:text-zinc-900">Show all</button> : null}
    </div>
  );
}
